import React, { useState } from 'react'
import { IconButton, Menu, MenuItem } from '@material-ui/core'
import { generateQuickAccess } from 'api/clients'

const QuickAccessButton = ({
  clientId,
  clientName,
  onQuickAccessGenerated,
  disabled = false,
  size = 'small'
}) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const isMenuOpen = Boolean(anchorEl)

  const handleMenuClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const handleGenerateQuickAccess = async () => {
    handleMenuClose()
    if (!clientId) return

    setIsLoading(true)
    try {
      const response = await generateQuickAccess(clientId)
      onQuickAccessGenerated(response)
    } catch (error) {
      console.error('Error generating quick access:', error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <IconButton
        onClick={handleMenuClick}
        size={size}
        title='Más opciones'
        disabled={disabled}
      >
        <i className='material-icons'>more_vert</i>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={isMenuOpen}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        <MenuItem
          onClick={handleGenerateQuickAccess}
          disabled={isLoading || !clientId}
        >
          <i
            className='material-icons'
            style={{ marginRight: '8px', fontSize: '20px' }}
          >
            link
          </i>
          Generar acceso rápido{clientName ? ` para ${clientName}` : ''}
        </MenuItem>
      </Menu>
    </>
  )
}

export default QuickAccessButton
